import * as AvatarPrimitive from "@radix-ui/react-avatar"
import clsx from "clsx"

import styles from "./Avatar.module.css"

export interface AvatarProps {
  imageUrl?: string
  firstName?: string
  lastName?: string
  hasBorder?: boolean
  size?: 16 | 24 | 32
}

export function Avatar(props: AvatarProps) {
  const {
    imageUrl,
    firstName = "",
    lastName = "",
    hasBorder = true,
    size = 32
  } = props

  const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase()

  return (
    <AvatarPrimitive.Root
      className={clsx(
        styles.root,
        hasBorder && styles.border,
        styles[`size-${size}`]
      )}
    >
      <AvatarPrimitive.Image src={imageUrl} className={styles.image} />
      <AvatarPrimitive.Fallback delayMs={imageUrl ? 600 : undefined}>
        {initials}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  )
}
